import { render, staticRenderFns } from "./seriesTypeModel.vue?vue&type=template&id=a58cc8be"
import script from "./seriesTypeModel.vue?vue&type=script&lang=js"
export * from "./seriesTypeModel.vue?vue&type=script&lang=js"
import style0 from "./seriesTypeModel.vue?vue&type=style&index=0&id=a58cc8be&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports